import get from 'lodash/get'
import API from 'shared/lib/api'

export default {

  // Create resource on the API.
  //
  // @example
  //   SomeModel.actions.updatePositions({ ids: [1,2,3,4,5] })
  //
  // @example
  //   SomeModel.actions.updatePositions({ id: 1, ids: [1,2,3,4,5] })
  //
  actionMethod: (model, options = {}) => {
    options.apiVersion = options.apiVersion || model.options.apiVersion

    if (options.apiVersion === 3) {
      const data = options.ids.map((id) => {
        return {
          type: model.pluralName,
          id
        }
      })

      return API.patch(`${model.pluralName}/positions`, {
        apiVersion: 3,
        data
      })
    } else {
      return API.post(`${model.pluralName}/update_positions`, options)
    }
  },

  // When a user reorders a list of models using drag-and-drop,
  // we optimistically update the positions of the models in the
  // client-side ORM, under the assumption that the API will succeed.
  //
  // When the API would fail, the client-side data is incorrect.
  // But ordering is a relatively low-risk feature, so we can
  // live with the risk of having it fail in rare situations.
  //
  // This optimism is mainly needed to support reordering of lines
  // of very big orders, where the user conceivably could drag
  // lines faster than the API can keep up.
  //
  reduceMethod: (model, collection, action) => {
    const options = get(action, 'payload.options', {})

    switch (action.type) {
      // v1/2/3 [Model].update_positions
      case model.actionTypes.UPDATE_POSITIONS_START: {
        const ids = get(options, 'ids', [])
        const newPositions = ids.map((id, index) => ({ id, position: index + 1 }))

        return collection.hydrate(newPositions)
      }
      // v4 SortingActions.create
      case 'SORTINGS_CREATE_START': {
        const modelName = get(options, 'attributes.type')
        if (modelName !== model.pluralName) {
          return null
        }

        const ids = get(options, 'attributes.ids', [])

        // Build a new array of objects with the new positions.
        // We make sure to only update the models that have changed,
        // to avoid unnecessary re-renders of other instances.
        const newPositions = []

        // Products have sorting_weight as sorting attribute
        if (modelName === 'products') {
          ids.forEach((id, index) => {
            const model = collection.getById(id)
            if (model.sorting_weight !== index + 1) {
              newPositions.push({ id, sorting_weight: index + 1 })
            }
          })
        } else {
          // ...all other models have position as sorting attribute
          ids.forEach((id, index) => {
            const model = collection.getById(id)
            if (model.position !== index + 1) {
              newPositions.push({ id, position: index + 1 })
            }
          })
        }

        return collection.hydrate(newPositions)
      }
    }
  }
}
